import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { GetCaptcha, GetOrg } from '@/api/sys.user';
import util from '@/libs/util.js';
export default {
  data: function data() {
    return {
      loginForm: {
        username: null,
        password: null,
        CaptchaCode: null,
        CaptchaId: null
      },
      loginFormRules: {
        username: [{
          required: true,
          message: this.$t('page.login.tips.username'),
          trigger: 'blur'
        } // { min: 3, max: 10, message: "长度在 3 到 10 个字符", trigger: "blur" }
        ],
        password: [{
          required: true,
          message: this.$t('page.login.tips.password'),
          trigger: 'blur'
        }, {
          min: 4,
          max: 30,
          message: '长度在 4 到 30 个字符',
          trigger: 'blur'
        }],
        CaptchaCode: [{
          required: true,
          message: this.$t('page.login.tips.verification'),
          trigger: 'blur'
        }]
      },
      btnLoading: false,
      isShowCaptcha: false,
      captchaImage: null
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['login'])), {}, {
    getOrgList: function getOrgList(userName) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return GetOrg(userName);

              case 2:
                res = _context.sent;
                _this.originList = res.data;

                _this.$nextTick(function () {
                  if (res.data.length > 0) {
                    _this.loginForm.organizeId = res.data[0].Id;
                    util.cookies.set('ORG_ID', res.data[0].SysOrganizeId);
                    util.cookies.set('ORG_CODE', res.data[0].OrganizeName);
                  }
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 点击验证码图片
    handleCaptchaImage: function handleCaptchaImage() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return GetCaptcha();

              case 2:
                res = _context2.sent;

                if (res.code === 0) {
                  _this2.captchaImage = "data:image/png;base64,".concat(res.data.code);
                  _this2.loginForm.CaptchaId = res.data.id;

                  _this2.$forceUpdate();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    captchaLogin: function captchaLogin(result) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var errorCount, msg;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                errorCount = result.errorCount + 0;
                msg = result.msg; // this.$message.warning(msg + ' , ' + '剩余错误次数：' + (4 - errorCount))

                _this3.$message.warning(msg);

                if (errorCount >= 4) {
                  _this3.isShowCaptcha = true;

                  _this3.handleCaptchaImage(); // let res = await GetCaptcha()
                  // console.log(res);
                  // if(res.code === 0){
                  //     this.captchaImage = `data:image/png;base64,${res.data.code}`
                  //     this.loginForm.CaptchaId = res.data.id
                  //     this.$forceUpdate()
                  // }

                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleLogin: function handleLogin() {
      var _this4 = this;

      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(bool) {
          var params, res;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!(bool === true)) {
                    _context4.next = 10;
                    break;
                  }

                  _this4.loading = true;
                  params = {
                    userName: _this4.loginForm.username,
                    password: _this4.loginForm.password,
                    CaptchaId: _this4.loginForm.CaptchaId,
                    CaptchaCode: _this4.loginForm.CaptchaCode
                  };
                  _this4.btnLoading = true;
                  _context4.next = 6;
                  return _this4.login(params);

                case 6:
                  res = _context4.sent;
                  _this4.btnLoading = false;
                  console.log('resresres', res);

                  if (res.errorCount) {
                    _this4.loading = false;

                    _this4.captchaLogin(res);
                  } else {
                    _this4.getOrgList(_this4.loginForm.username);

                    _this4.$message.success('登录成功');

                    _this4.$router.push('/index');

                    _this4.loading = false;
                  } // console.log('res',res);
                  // if(res.code === 0){
                  //     this.$message.success('登录成功')
                  //     this.$router.push('/index')
                  //     this.loading = false
                  // }else{
                  //     this.loading = false
                  //     this.$message.warning(res.message)
                  // }


                case 10:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  })
};